import React, { useState, useEffect } from 'react';
import './Partners.css';
import SectionTitle from '../SectionTitle/SectionTitle';
import Button from '../Button/Button';
import chunk from 'lodash/chunk';
import COS_LOGO_ROUND from '../../images/COS_LOGO_ROUND.png';

const importAll = (require) => {
  return require.keys().map(require);
};

const Partners = () => {
  const [allImages, setAllImages] = useState([]);
  const [firstImages, setFistImages] = useState([]);
  const [displayedImages, setDisplayedImages] = useState([]);
  const [isOnlyFirstImages, setIsOnlyFirstImages] = useState(true);

  useEffect(() => {
    const allImages = importAll(
      require.context(
        '../../images/partenaires',
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );
    const firstImages = chunk(allImages, 15)[0];
    setAllImages(allImages);
    setFistImages(firstImages);
    setDisplayedImages(firstImages);
  }, []);

  return (
    <div className="Partners">
      <SectionTitle classname="Partners__title">
        Nos
        <strong className="SectionTitle__item--bold">&nbsp;partenaires</strong>
      </SectionTitle>
      <div className="Partners__container">
        <img
          src={COS_LOGO_ROUND}
          className="Partners__logo"
          alt="smile"
          loading="lazy"
        />
        <div className="Partners__images">
          {displayedImages.map((image) => {
            return (
              <div
                className="Partners__image"
                style={{ backgroundImage: `url(${image})` }}
              ></div>
            );
          })}
        </div>
        <Button
          onClick={() => {
            if (isOnlyFirstImages) {
              setDisplayedImages(allImages);
              setIsOnlyFirstImages(false);
            } else {
              setDisplayedImages(firstImages);
              setIsOnlyFirstImages(true);
            }
          }}
          type="button"
          grey={true}
          classname="Partners__button"
        >
          {isOnlyFirstImages ? 'En voir plus' : 'En voir moins'}
        </Button>
      </div>
    </div>
  );
};

export default Partners;
